import React from "react";
import { Redirect } from "react-router-dom";
import { Mutation,Query } from "react-apollo";
import Text from "../Type/Text";
import Button from "../UI/Button";
import gql from "graphql-tag";
import CaregiverSelect from "../User/Select/Container"
import InputSelect from "../UI/Input/Select"

import { Rowz, Spacer } from "../Layout/Layout";

const REMOVE_CAREGIVER_FROM_JOB = gql`
  mutation removeCaregiverFromJob($jobID: ID!, $caregiverID: ID!) {
    removeCaregiverFromJob(jobID: $jobID, caregiverID: $caregiverID) {
      id
      firstName
      lastName
    }
  }
`;

const GET_CAREGIVER_JOBS = gql`
  query getCaregiverJobs($caregiverID: ID!){
    getUser(userID: $caregiverID){
      id
      jobs{
        id
        title
      }
    }
  }
`

class RemoveCaregiverToJobForm extends React.Component {
  state = {
    jobID: null,
    caregiverID: null
  };

  handleInputChange = (name, value) => {
    this.setState({
      [name]: value
    });
  };

  render() {
    return (
      <Mutation mutation={REMOVE_CAREGIVER_FROM_JOB}>
        {(removeCaregiverFromJob, { data, loading, called, error }) => {
          if (called && !error && !loading) {
            if (data.removeCaregiverFromJob) {
              return (
                <Redirect
                  to={{
                    pathname: "/",
                    state: {
                      message: `Job successfully removed of ${data.removeCaregiverFromJob.firstName} ${data.removeCaregiverFromJob.lastName}`
                    }
                  }}
                />
              );
            }
          }

          return (
            <React.Fragment>
              <form
                onSubmit={e => {
                  e.preventDefault();
                  removeCaregiverFromJob({ variables: this.state });
                }}
              >
                <Spacer>
                  <Spacer>
                    <Rowz>
                      <Text>Caregiver:</Text>
                      <CaregiverSelect filterRole="CAREGIVER" onChange={value => this.handleInputChange("caregiverID",parseInt(value))} />
                    </Rowz>
                  </Spacer>
                  <Spacer>
                    <Rowz>
                      <Text>Job:</Text>
                      {this.state.caregiverID ? <Query query={GET_CAREGIVER_JOBS} variables={{caregiverID: this.state.caregiverID} } fetchPolicy="no-cache">
                        {({loading,error,data})=>{
                          let jobOptions = []
                          if(!loading && !error && data){
                            jobOptions = data.getUser.jobs.map(j=>({value: j.id, text: j.title}))
                          }
                          
                          return <InputSelect
                          options={jobOptions}
                          onChange={value => this.handleInputChange("jobID",parseInt(value))}
                          defaultText="-- Select job --"
                          />
                          

                        }}
                      </Query> : ""}
                      
                    </Rowz>
                  </Spacer>
                  
                  <Spacer>
                    <Button type="submit" disabled={loading}>
                      Submit
                    </Button>
                  </Spacer>
                </Spacer>
              </form>
            </React.Fragment>
          );
        }}
      </Mutation>
    );
  }
}

export default RemoveCaregiverToJobForm;
